import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import FormValidationsMixin, { validMobileNumber, } from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required, email } from 'vuelidate/lib/validators';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import mutation from '@/plugins/graphql/mutations/v2/user-settings-update.gql';
import { MOBILE_MASK } from '@/helpers/constants/app';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let CompleteUserProfileDialog = class CompleteUserProfileDialog extends Mixins(Mixins(FormMixin, ButtonLoaderMixin, FormValidationsMixin), AlertMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            birthdate: this.birthdate,
            contactNumber: this.contact,
            businessEmailAddress: this.businessEmail,
        };
    }
    get description() {
        return 'To enhance the security of your ChatGenie account, please provide your birthdate and mobile number. This information will be used to verify your identity and protect your account.';
    }
    onDialCodeChange({ dialCode }) {
        this.form.dialCode = `+${dialCode}`;
    }
    get mobileMask() {
        return MOBILE_MASK;
    }
    get contactNum() {
        const { contactNumber } = this.form;
        if (contactNumber.includes('+63'))
            return contactNumber.replaceAll(' ', '').substr(3, contactNumber.length);
        return contactNumber;
    }
    async updateUser() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            await this.onSave();
        }
    }
    async onSave() {
        const { birthdate, businessEmailAddress, contactNumber, contactDialCode } = this.form;
        return this.$apollo
            .mutate({
            mutation,
            variables: {
                input: {
                    userUuid: this.userUuid,
                    contactNumber: this.contactNum,
                    contactDialCode: '+63',
                    businessEmailAddress,
                    birthdate,
                },
            },
        })
            .then(() => {
            this.$emit('update:success');
            this.successNotification('Account Information Updated');
            this.onAccountSecurityUpdate();
        });
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], CompleteUserProfileDialog.prototype, "value", void 0);
__decorate([
    Prop({ type: String, required: true })
], CompleteUserProfileDialog.prototype, "userUuid", void 0);
__decorate([
    Prop({ type: String, required: false })
], CompleteUserProfileDialog.prototype, "birthdate", void 0);
__decorate([
    Prop({ type: String, required: false })
], CompleteUserProfileDialog.prototype, "contact", void 0);
__decorate([
    Prop({ type: String, required: false })
], CompleteUserProfileDialog.prototype, "dialCode", void 0);
__decorate([
    Prop({ type: String, required: false })
], CompleteUserProfileDialog.prototype, "businessEmail", void 0);
CompleteUserProfileDialog = __decorate([
    Component({
        components: { ActionButton, BaseTextField, BaseDatePicker, PhoneInput },
        validations: {
            form: {
                birthdate: { required },
                contactNumber: { required, validMobileNumber },
                businessEmailAddress: { required, email },
            },
        },
    })
], CompleteUserProfileDialog);
export default CompleteUserProfileDialog;
